import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiUrlService } from './api-url.service';
import { ConversationList, Message } from '../models/interfaz';

@Injectable({
  providedIn: 'root'
})
export class WhatsappService {
  constructor(private apiUrl: ApiUrlService, private http: HttpClient) {}

  private withPhoneQuery(url: string, phone: string): string {
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}phone=${encodeURIComponent(phone)}`;
  }

  getConversationList(): Observable<ConversationList[]> {
    const url = `${this.apiUrl.whatsappListAPI}`;
    return this.http.get<ConversationList[]>(url);
  }

  getWhatsappDetails(phone: string): Observable<Message[]> {
    const url = this.withPhoneQuery(this.apiUrl.whatsappDetailsAPI, phone);
    return this.http.get<Message[]>(url);
  }

  sendWhatsappMessage(phone: string, body: string, context_message_id?: string | null): Observable<Message> {
    const url = this.withPhoneQuery(this.apiUrl.whatsappSendMessageAPI, phone);
    return this.http.post<Message>(url, {
      body,
      context_message_id: context_message_id || null
    });
  }

  deleteWhatsappMessage(messageId: string): Observable<{ status: string }> {
    const url = `${this.apiUrl.whatsappDeleteMessageAPI}/${encodeURIComponent(messageId)}`;
    return this.http.delete<{ status: string }>(url);
  }
}
